import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'highlight'
})
export class HighlightPipe implements PipeTransform {
  escapeRegex(string) {
    return string.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
  }

  transform(el: string, elToHighlight: string, regEx: boolean = false): string {
    if (!el || !elToHighlight) {
      return el;
    }

    if(el.length>=34){
      let shortel=  el.substring(0,20);
      let rest=  el.substring(20,el.length);
      const hilightedShortStr = this.applyHighlight(shortel, elToHighlight, regEx);
   
    

        if(this.doContainValueToHighlight(el,elToHighlight,regEx)) {
          return hilightedShortStr+'<span class="highlight">' + '...' + '</span>';

        } else {
         
          return hilightedShortStr + '...';

        }
    
    }

    return this.applyHighlight(el, elToHighlight, regEx);
  }

  applyHighlight(el, elToHighlight, isRegex) {
    if (isRegex) {
      return el.replace(new RegExp(elToHighlight, 'gi'), match => {
        return '<span class="highlight">' + match + '</span>';
      });
    } else {

      return el.replace(new RegExp(this.escapeRegex(elToHighlight), 'gi'), match => {
        return '<span class="highlight">' + match + '</span>';
      });
    }
  }

  doContainValueToHighlight(el, elToHighlight, isRegex) {
    var n = el.toLowerCase().lastIndexOf(elToHighlight.toLowerCase());
    

    if (isRegex) {
      
      return new RegExp(elToHighlight, 'gi').test(el);
    } else {
      return new RegExp(this.escapeRegex(elToHighlight), 'gi').test(el);
    }
  }
}
